export default __webpack_public_path__ + "static/kubernetes-logo-c299129c0d0f391fafed30adea41ccc1.svg";